export default __webpack_public_path__ + "static/media/box-4Closed.72a5f280.jpg";